/**
 * Upgrade Tiers Frontend Handler
 */

document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.xtra-upgrade-tiers__button');
    
    buttons.forEach(button => {
        button.addEventListener('click', async (e) => {
            e.preventDefault();
            
            const container = button.closest('.xtra-upgrade-tiers__action');
            const messageDiv = container.querySelector('.xtra-upgrade-tiers__message');
            const originalText = button.textContent;
            
            // Show loading state
            button.disabled = true;
            button.textContent = 'Loading...';
            messageDiv.style.display = 'none';
            messageDiv.className = 'xtra-upgrade-tiers__message';
            
            // Get return URL from data attribute
            const returnUrl = button.dataset.returnUrl || window.location.href;
            
            try {
                // Make request to create portal session
                const response = await fetch('/wp-json/xtraxtra-stripe/v1/portal', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': XXRest.nonce
                    },
                    body: JSON.stringify({
                        return_url: returnUrl
                    })
                });
                
                const data = await response.json();
                
                if (response.ok && data.url) {
                    // Redirect to Stripe Customer Portal
                    window.location.href = data.url;
                } else {
                    // Show error message
                    const errorMessage = data.message || 'Failed to open subscription management. Please try again.';
                    messageDiv.textContent = errorMessage;
                    messageDiv.className = 'xtra-upgrade-tiers__message error';
                    messageDiv.style.display = 'block';
                    
                    // Reset button
                    button.disabled = false;
                    button.textContent = originalText;
                }
            } catch (error) {
                // Show network error
                messageDiv.textContent = 'Network error. Please check your connection and try again.';
                messageDiv.className = 'xtra-upgrade-tiers__message error';
                messageDiv.style.display = 'block';
                
                // Reset button
                button.disabled = false;
                button.textContent = originalText;
            }
        });
    });
});